import { render, staticRenderFns } from "./ProjectManage.vue?vue&type=template&id=6562dcd3&scoped=true"
import script from "./ProjectManage.vue?vue&type=script&lang=js"
export * from "./ProjectManage.vue?vue&type=script&lang=js"
import style0 from "./ProjectManage.vue?vue&type=style&index=0&id=6562dcd3&prod&scoped=true&lang=css"
import style1 from "@/styles/approval-status.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6562dcd3",
  null
  
)

export default component.exports